export default __webpack_public_path__ + "static/media/Duration_Icon.46041be5.png";